import React from "react";
import * as styles from "./Hint.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Icon from "../Icon/Icon";

const Hint = ({ label, small = false, className, icon = "warning", simple = false, inline = false }) => {
	const hintClassName = classNames({
		[styles["hint"]]: !simple,
		[styles["hint-small"]]: small,
		[styles["hint-inline"]]: inline,
		[className]: !!className,
	});

	return (
		<div className={hintClassName}>
			{!simple && (
				<div className={styles["icon-box"]}>
					<Icon icon={icon} size={16} />
				</div>
			)}
			<div className={styles["label"]}>{label}</div>
		</div>
	);
};

Hint.propTypes = {
	label: PropTypes.string.isRequired,
	icon: PropTypes.string,
	small: PropTypes.bool,
	className: PropTypes.string,
};

export default Hint;
